import * as THREE from 'three';
import { Tween, Easing } from "es6-tween";

const polarMaxAngle = Math.PI * 0.5;
const polarMinAngle = Math.PI * 0.5;


export function GetBackMesh(r, transparent) {
	const sphereGeo = new THREE.SphereGeometry(r, 64, 64);
	const sphereMat = new THREE.MeshBasicMaterial({ color: 0xFFFFFF, side: 1, transparent });
	const backMesh = new THREE.Mesh(sphereGeo, sphereMat);
	backMesh.scale.x = -1;
	return backMesh;
}

function getDevice() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/windows phone/i.test(userAgent)) { return "windows"; }
    if (/android/i.test(userAgent)) { return "android"; }
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) { return "ios"; }

    return undefined;
}

function isIOS() {
    if (/iPad|iPhone|iPod/.test(navigator.platform)) {
        return true;
    } else {
        return navigator.maxTouchPoints &&
        navigator.maxTouchPoints > 2 &&
        /MacIntel/.test(navigator.platform);
    }
}

function isIpadOS() {
    return navigator.maxTouchPoints &&
        navigator.maxTouchPoints > 2 &&
        /MacIntel/.test(navigator.platform);
}
const device = getDevice();


let thermatru_areal_fov = 60
let fypon_area_fov = 40
let prmedia_fov = 100

if(device === undefined) {

	if(isIOS()) {
		thermatru_areal_fov = 80
		fypon_area_fov = 60
	}
	if(isIpadOS()) {
		thermatru_areal_fov = 80
		fypon_area_fov = 60

	}
}


export const camPosHome = { x: 0.0967, y: 0.0022, z: -0.0251, fov: 50 };
export const controlHome = { azimuth: { max: 1.94, min: 1.81 }, polar: { max: 1.84, min: 1.20 } };

export const modelArr = [

	{
		key: 'thermatru_arial', modelSrc: 'balance_panorama.fbx', backImg: 'thermatru_areal.jpg', apiId: 4,
		backRot: 0, hotPosY0: 0,
		campos: [
			{ x: 1.4792796542601254, y: 0.34628733174871495, z: -0.04336160009023865, fov: thermatru_areal_fov, backImg: 'balance-back_0.jpg' },

		],
		control: [
			{ azimuth: { max: 1.7, min: 1.7 }, polar: { max: 1.4, min: 0.9 } },

		],

		navigationElements: [
			{
				name: 'fypon',
				pos: { x: -21.320, y: -2.464, z: 13.470 },
				rot: { x: 3.140, y: 5.411, z: -3.123 },
				scale: { x: 1.860, y: 0.900, z: 1 },
				size: { w: 1.8, h: 2.3 },
				shadow: { pos: { x: -13.880, y: -1.764, z: 12.330 }, rot: { x: 3.140, y: 5.411, z: -3.123 }, scale: { x: 1.860, y: 1.230, z: 1 } }
			},
			{
				name: 'prmedia', pos: { x: -22.630, y: -1.474, z: -15.100 }, rot: { x: 0.140, y: 0, z: -0.200 }, scale: { x: 1.860, y: 0.900, z: 1 }, size: { w: 1.8, h: 2.3 },
				shadow: { pos: { x: -13.880, y: -1.764, z: 12.330 }, rot: { x: 3.140, y: 5.411, z: -3.123 }, scale: { x: 1.860, y: 1.230, z: 1 } }
			}
		],
		frames: [{ frameKey: 'thermatru_video', type: 'video', fileName: 'Rotating_Door', scale: { x: 0.620, y: 0.720, z: 1 }, pos: { x: -14.615, y: -2.130, z: 10.290 }, rot: { x: 0.000, y: 2.560, z: 0.161 } },],
		hotspot: [
			{
				pos: { x: -14.340, y: -4.640, z: 8.470 },
				rot: { x: -0.210, y: -0.490, z: -0.300 },
				rotNeed: true,
				name: 'thermatru_difference',
				ref: 'thermatru_arial_hotspot1',
				textPos: { x: 8.430, y: 9.760, z: -11.960 },
				textRot: { x: -3.142, y: 2.7, z: -3.142 },
				textName: "The Therma-Tru \n Difference ",
				color: 'red',
				type: 'thermatru',
				textKey: 'text_therma_differ'
			},
			{
				pos: { x: -14.340, y: -3.270, z: 3.020 },
				rot: { x: -0.210, y: -0.490, z: -0.300 },
				rotNeed: true,
				name: 'thermatru_new_products',
				ref: 'thermatru_arial_hotspot2',
				textPos: { x: 7.410, y: 9.000, z: -7.120 },
				textRot: { x: -3.142, y: 2.4, z: -3.142 },
				textScale: { x: 1.190, y: 1.240, z: 1.080 },
				textName: "Trends & New \n Products",
				color: 'red',
				type: 'thermatru',
				textKey: 'text_therma_trends'
			},
			{
				pos: { x: -14.340, y: -4.030, z: -8.240 },
				rot: { x: -0.210, y: -0.490, z: -0.300 },
				rotNeed: true,

				name: 'thermatru_tools_support',
				ref: 'thermatru_arial_hotspot3',
				textPos: { x: 11.720, y: 9.000, z: -3.160 },
				textRot: { x: -3.142, y: 1.8, z: -3.142 },
				textName: "Tools & Support",
				color: 'red',
				type: 'thermatru',
				textKey: 'text_therma_tools'
			},
			{
				pos: { x: -14.340, y: -10.980, z: -1.920 },
				rot: { x: -0.210, y: -0.490, z: -0.300 },
				rotNeed: true,

				name: 'thermatru_key_success',
				ref: 'thermatru_arial_hotspot4',
				textPos: { x: 9.770, y: 9.000, z: -5.520 },
				textRot: { x: -3.142, y: 2.1, z: -3.142 },
				textName: "Key 2 Success",
				color: 'red',
				type: 'thermatru',
				textKey: 'text_therma_keys'
			},

		],
		infospot: []
	},
	{
		key: 'thermatru_key_success', modelSrc: 'balance_panorama.fbx', backImg: 'thermatru_key_success.jpg', apiId: 4,
		backRot: 0, hotPosY0: 0,
		campos: [
			{ x: 0.2448, y: -0.01352, z: 0.00058, fov: 75, backImg: 'balance-back_0.jpg' },

		],
		control: [
			{ azimuth: { max: 1.8, min: 1.5 }, polar: { max: polarMaxAngle, min: polarMinAngle } },

		],
		navigationElements: [
			{ name: 'fypon', pos: { x: -8.270, y: -2.534, z: 28.010 }, rot: { x: 3.140, y: 5.411, z: -3.123 }, scale: { x: 1.860, y: 1.230, z: 1 }, size: { w: 1.8, h: 2.3 } },
			{ name: 'prmedia', pos: { x: -12.990, y: -1.834, z: -21.980 }, rot: { x: 0, y: 0, z: 0 }, scale: { x: 1.860, y: 1.230, z: 1 }, size: { w: 1.8, h: 2.3 } }
		],
		frames: [{ frameKey: 'thermatru_video', type: 'video', fileName: 'Rotating_Door', scale: { x: 1.240, y: 1.480, z: 1 }, pos: { x: -20, y: 0.2, z: 21.450 }, rot: { x: 0, y: -1.1, z: 0 } },],
		hotspot: [
			{
				pos: { x: -13.430, y: -3.140, z: 13.340 },
				rot: { x: -1.422, y: -0.088, z: 0.152 },
				name: 'thermatru_difference',
				ref: 'thermatru_key_success_hotspot1',
				textPos: { x: 9.770, y: 9.000, z: -4.480 },
				textRot: { x: 0, y: 2.440, z: 0 },
				textName: "New Products",
				color: 'red',
				type: 'thermatru',
				textKey: 'text_therma_differ'

			},
			{
				pos: { x: -20.200, y: -3.210, z: 9.990 },
				rot: { x: -1.422, y: -0.088, z: 0.152 },
				name: 'thermatru_new_products',
				ref: 'thermatru_key_success_hotspot2',
				textPos: { x: 9.770, y: 9.000, z: -4.480 },
				textRot: { x: 0, y: 2.240, z: 0 },
				textName: "Explore Fypon",
				color: 'red', type: 'thermatru',
				textKey: 'text_therma_trends'

			},
			{
				pos: { x: -18.620, y: -3.370, z: -13.710 },
				rot: { x: -1.422, y: -0.088, z: 0.152 },
				name: 'thermatru_tools_support',
				ref: 'thermatru_key_success_hotspot3',
				textPos: { x: 9.770, y: 9.000, z: -4.480 },
				textRot: { x: 0, y: 0.840, z: 0 },
				textName: "Explore Fypon",
				color: 'red', type: 'thermatru',
				textKey: 'text_therma_tools'

			},
			{
				pos: { x: -10.070, y: -3.660, z: -11.800 },
				rot: { x: -1.422, y: -0.088, z: 0.152 },
				name: 'fypon_advantage',
				ref: 'thermatru_key_success_hotspot4',
				textPos: { x: 9.770, y: 9.000, z: -4.480 },
				textRot: { x: 0, y: 0.6, z: 0 },
				textName: "Explore Fypon",
				color: 0x0079C2
				, type: 'fypon',
				textKey: 'text_fypon_advant',
				guided_path_show: true

			},


		],
		infospot: [

			{
				pos: new THREE.Vector3(-20.810, -7.120, -0.640),
				rot: new THREE.Vector3(-1.422, -0.088, 0.152),
				name: 'rotation_keysuccess',
				needRotation: false

			},
		]
	},
	{
		key: 'thermatru_difference', modelSrc: 'balance_panorama.fbx', backImg: 'thermatru_difference.jpg', apiId: 4,
		backRot: 0, hotPosY0: 0,
		campos: [
			{ x: 0.2448, y: -0.01352, z: 0.00058, fov: 70, backImg: 'balance-back_0.jpg' },

		],
		control: [
			{ azimuth: { max: 1.5, min: 0.25 }, polar: { max: polarMaxAngle, min: polarMinAngle } },

		],
		navigationElements: [
			{ name: 'fypon', pos: { x: -16.855, y: -2.394, z: 19.791 }, rot: { x: 3.140, y: 5.411, z: -3.123 }, scale: { x: 3.090, y: 2.220, z: 1 }, size: { w: 1.8, h: 2.3 } },
			{ name: 'prmedia', pos: { x: 19.455, y: -1.074, z: -21.299 }, rot: { x: 0, y: 0, z: 0 }, scale: { x: 1.860, y: 1.230, z: 1 }, size: { w: 1.8, h: 2.3 } }
		],
		frames: [{ frameKey: 'thermatru_video', type: 'video', fileName: 'Rotating_Door', scale: { x: 2.9, y: 3.65, z: 1 }, pos: { x: -21.925, y: -0.264, z: -0.199 }, rot: { x: 0, y: 1.57, z: 0 } },],
		hotspot: [
			{
				pos: { x: -8.570, y: -3.760, z: -9.410 },
				rot: { x: -1.422, y: -0.088, z: 0.152 },
				name: 'thermatru_new_products',
				ref: 'thermatru_difference_hotspot1',
				textPos: { x: 9.770, y: 9.000, z: -4.480 },
				textRot: { x: 0, y: 7.040, z: 0 },
				textName: "New Products",
				color: 'red',
				type: 'thermatru',
				textKey: 'text_therma_trends'

			},
			{
				pos: { x: 7.660, y: -3.070, z: -11.720},
				rot: { x: -1.422, y: -0.088, z: 0.152 },
				name: 'thermatru_key_success',
				ref: 'thermatru_difference_hotspot2',
				textPos: { x: 9.770, y: 9.000, z: -4.480 },
				textRot: { x: 0, y: 5.840, z: 0 },
				textName: "Explore Fypon",
				color: 'red', type: 'thermatru',
				textKey: 'text_therma_keys'

			},

			{
				pos: { x: 12.250, y: -3.050, z: -21.130 },
				rot: { x: -1.422, y: -0.088, z: 0.152 },
				name: 'thermatru_tools_support',
				ref: 'thermatru_difference_hotspot3',
				textPos: { x: 9.770, y: 9.000, z: -4.480 },
				textRot: { x: 0, y: 5.840, z: 0 },
				textName: "Explore Fypon",
				color: 'red', type: 'thermatru',
				textKey: 'text_therma_tools'

			},

		],
		infospot: [
			{
				pos: new THREE.Vector3(-21.810, -0.220, 11.290),
				rot: new THREE.Vector3(-1.422, -0.088, 0.152),
				name: 'experience_image1_modal',
				ref: 'experience_image1_modal',

				needRotation: false

			},
			{
				pos: new THREE.Vector3(-21.810, -2.860, 9.640),
				rot: new THREE.Vector3(-1.422, -0.088, 0.152),
				name: 'experience_image2_modal',
				ref: 'experience_image2_modal',

				needRotation: false

			},
			{
				pos: new THREE.Vector3(-21.810, 2, 9.8),
				rot: new THREE.Vector3(-1.422, -0.088, 0.152),
				name: 'experience_image3_modal',
				ref: 'experience_image3_modal',
				needRotation: false

			},

			{
				pos: new THREE.Vector3(-20.810, -3.770, 5.930),
				rot: new THREE.Vector3(-1.422, -0.088, 0.152),
				name: 'experience_thermatru',
				needRotation: false

			},
			{
				pos: new THREE.Vector3(-20.810, -3.770, -3.290),
				rot: new THREE.Vector3(-1.422, -0.088, 0.152),
				name: 'fiberglass_full_advantage',
				needRotation: false

			},
			{
				pos: new THREE.Vector3(-21.140, -4.030, -13.560),
				rot: new THREE.Vector3(-1.422, -0.088, 0.152),
				name: 'thermatru_thrives',
				needRotation: false

			},
		]


	},
	{
		key: 'thermatru_new_products', modelSrc: 'balance_panorama.fbx', backImg: 'thermatru_trends_new_products.jpg', apiId: 4,
		backRot: 0, hotPosY0: 0,
		campos: [
			{ x: 0.24491052912003788, y: -0.006267950073578917, z: 0.009471659200889373, fov: 60, backImg: 'balance-back_0.jpg' },

		],
		control: [
			{ azimuth: { max: 2.3, min: 0.42 }, polar: { max: polarMaxAngle, min: polarMinAngle } },

		],

		navigationElements: [
			{ name: 'fypon', pos: { x: -0.475, y: -2.414, z: 28.171 }, rot: { x: 3.140, y: 5.411, z: -3.123 }, scale: { x: 3.090, y: 2.220, z: 1 }, size: { w: 1.8, h: 2.3 } },
			{ name: 'prmedia', pos: { x: 16.015, y: -1.074, z: -21.109 }, rot: { x: 0, y: 0, z: 0 }, scale: { x: 1.860, y: 1.230, z: 1 }, size: { w: 1.8, h: 2.3 } }
		],
		frames: [{ frameKey: 'thermatru_video', type: 'video', fileName: 'Rotating_Door', scale: { x: 2.26, y: 2.99, z: 1 }, pos: { x: -11.110, y: -0.03, z: 25.5 }, rot: { x: 0, y: -1.1, z: 0 } },],
		hotspot: [
			{
				pos: { x: -10.810, y: -5.090, z: 9.440 },
				rot: { x: -1.422, y: -0.088, z: 0.152 },
				name: 'thermatru_difference',
				ref: 'thermatru_new_produts_hotspot1',
				textPos: { x: 9.770, y: 9.000, z: -4.480 },
				textRot: { x: 0, y: 2.440, z: 0 },
				textName: "New Products",
				color: 'red'
				, type: 'thermatru',
				textKey: 'text_therma_differ'


			},
			{
				pos: { x: -7.140, y: -3.640, z: -5.710 },
				rot: { x: -1.422, y: -0.088, z: 0.152 },
				name: 'thermatru_tools_support',
				ref: 'thermatru_new_produts_hotspot2',
				textPos: { x: 9.770, y: 9.000, z: -4.480 },
				textRot: { x: 0, y: 0.840, z: 0 },
				textName: "New Products",
				color: 'red'
				, type: 'thermatru',
				textKey: 'text_therma_tools'

			},
			{
				pos: { x: 15.790, y: -6.350, z: -22.160 },
				rot: { x: -1.422, y: -0.088, z: 0.152 },
				name: 'thermatru_key_success',
				ref: 'thermatru_new_produts_hotspot3',
				textPos: { x: 9.770, y: 9.000, z: -4.480 },
				textRot: { x: 0, y: 2.840, z: 0 },
				textName: "New Products",
				color: 'red'
				, type: 'thermatru',
				textKey: 'text_therma_keys'

			},


		],
		infospot: [
			{
				pos: new THREE.Vector3(-21.140, -4.910, -9.420),
				rot: new THREE.Vector3(-1.422, -0.088, 0.152),
				name: 'new_products',
				needRotation: false

			},
			{
				pos: new THREE.Vector3(-21.140, -4.820, 0.590),
				rot: new THREE.Vector3(-1.422, -0.088, 0.152),
				name: '2023_trends',
				needRotation: false

			},
		]


	},
	{
		key: 'thermatru_tools_support', modelSrc: 'balance_panorama.fbx', backImg: 'thermatru_tools_support.jpg', apiId: 4,
		backRot: 0, hotPosY0: 0,
		campos: [
			{ x: 1.72, y: 1.72, z: -0.00004, fov: 70, backImg: 'balance-back_0.jpg' },

		],
		control: [
			{ azimuth: { max: 2.9, min: 1.6 }, polar: { max: polarMaxAngle, min: polarMinAngle } },

		],

		navigationElements: [
			{ name: 'fypon', pos: { x: 12.485, y: -1.644, z: 24.011 }, rot: { x: 3.140, y: 5.411, z: -3.123 }, scale: { x: 1.460, y: 1, z: 1 }, size: { w: 1.8, h: 2.3 } },
			{ name: 'prmedia', pos: { x: -6.385, y: -2.574, z: -11.730 }, rot: { x: 0, y: 0, z: 0 }, scale: { x: 1.460, y: 1, z: 1 }, size: { w: 1.8, h: 2.3 } }
		],
		frames: [{ frameKey: 'thermatru_video', type: 'video', fileName: 'Rotating_Door', scale: { x: 0.630, y: 0.920, z: 1 }, pos: { x: 9.170, y: 0.180, z: 19.030 }, rot: { x: 0, y: 0, z: 0 } },],
		hotspot: [
			{
				pos: { x: 10.770, y: -3.190, z: 26.550 },
				rot: { x: -1.422, y: -0.088, z: 0.152 },
				name: 'thermatru_difference',
				ref: 'thermatru_tools_support_hotspot1',
				textPos: { x: 9.770, y: 9.000, z: -4.480 },
				textRot: { x: 0, y: 3.440, z: 0 },
				textName: "New Products",
				color: 'red'
				, type: 'thermatru',
				textKey: 'text_therma_differ'

			},
			{
				pos: { x: -8.610, y: -4.600, z: 10.010 },
				rot: { x: -1.422, y: -0.088, z: 0.152 },
				name: 'thermatru_new_products',
				ref: 'thermatru_tools_support_hotspot2',
				textPos: { x: 9.770, y: 9.000, z: -4.480 },
				textRot: { x: 0, y: 2.440, z: 0 },
				textName: "New Products",
				color: 'red'
				, type: 'thermatru',
				textKey: 'text_therma_trends'

			},
			{
				pos: { x: -7.110, y: -5.800, z: 6.570 },
				rot: { x: -1.422, y: -0.088, z: 0.152 },
				name: 'thermatru_key_success',
				ref: 'thermatru_tools_support_hotspot3',
				textPos: { x: 9.770, y: 9.000, z: -4.480 },
				textRot: { x: 0, y: 2.340, z: 0 },
				textName: "New Products",
				color: 'red'
				, type: 'thermatru',
				textKey: 'text_therma_keys'

			},


		],
		infospot: [

			{
				pos: new THREE.Vector3(-21.070, -4.290, 5.710),
				rot: new THREE.Vector3(-1.422, -0.088, 0.152),
				name: 'tools_explore_more',
				needRotation: false

			},

			{
				pos: new THREE.Vector3(-20.810, -4.290, -14.630),
				rot: new THREE.Vector3(-1.422, -0.088, 0.152),
				name: 'expert_guidance',
				needRotation: false

			},
		],
		imageElements: [

			{
				pos: new THREE.Vector3(-20.050, -5.550, 9.480),
				name: 'TT_tools_Support_Subheader_Link',
				link: 'https://www.thermatru.com/',
				rot: new THREE.Vector3(0, 1.691, 0)

			}

		]


	},

	{
		key: 'thermatru_certified_installer', modelSrc: 'balance_panorama.fbx', backImg: 'thermatru_tools_support.jpg', apiId: 4,
		backRot: 0, hotPosY0: 0,
		campos: [
			{ x: 0.23738159295256486, y: -0.01607581514783597, z: 0.059175284491374845, fov: 75, backImg: 'balance-back_0.jpg' },

		],
		control: [
			{ azimuth: { max: Infinity, min: -Infinity }, polar: { max: polarMaxAngle, min: polarMinAngle } },

		],
		hotspot: [
			{
				pos: { x: -1.850, y: -3.670, z: 27.300 },
				rot: { x: -1.422, y: -0.088, z: 0.152 },
				name: 'thermatru_new_products',
				ref: 'thermatru_certified_installer_hotspot1',
				textPos: { x: 9.770, y: 9.000, z: -4.480 },
				textRot: { x: 0, y: 2.840, z: 0 },
				textName: "New Products",
				color: 'red'
				, type: 'thermatru'

			},
			// {
			// 	pos : {x:  -11.690, y:-3.670, z: -4.480},

			// 	pos : {x:  -12.290, y: -3.670, z: 4.300},
			// 	rot : {x : -1.422,y : -0.088,z : 0.152},
			// 	name : 'thermatru_tools_support',
			// 	ref : 'thermatru_certified_installer_hotspot2',
			// 	textPos : {x:  9.770, y:9.000, z: -4.480 },
			// 	textRot : {x: 0, y: 2.840, z: 0 },
			// 	textName : "New Products"
			// },

		],
		infospot: [
			{
				pos: new THREE.Vector3(-21.140, -2.150, 3.140),
				rot: new THREE.Vector3(-1.422, -0.088, 0.152),
				name: 'tools_explore_more',
				needRotation: false

			},
			{
				pos: new THREE.Vector3(-20.810, -2.150, -8.990),
				rot: new THREE.Vector3(-1.422, -0.088, 0.152),
				name: 'expert_guidance',
				needRotation: false

			},

		]


	},


	{
		key: 'prmedia', modelSrc: 'balance_panorama.fbx', backImg: 'pr_media.jpg', apiId: 4,
		backRot: 0, hotPosY0: 0,
		campos: [
			{ x: 0.2448, y: -0.01352, z: 0.00058, fov: prmedia_fov, backImg: 'balance-back_0.jpg' },

		],
		control: [
			{ azimuth: { max: 1.6, min: 1.5 }, polar: { max: polarMaxAngle, min: polarMinAngle } },

		],

		navigationElements: [
			{ name: 'thermatru', pos: { x: -6.495, y: -2.404, z: 8.380 }, rot: { x: 3.140, y: 5.411, z: -3.123 }, scale: { x: 1.460, y: 1, z: 1 }, size: { w: 1.8, h: 2.3 } },
			{ name: 'fypon', pos: { x: -7.915, y: -3.154, z: -9.240 }, rot: { x: 0, y: 0, z: 0 }, scale: { x: 1.460, y: 1, z: 1 }, size: { w: 1.8, h: 2.3 } }
		],
		hotspot: [

		],
		infospot: [
			{
				pos: new THREE.Vector3(2.250, -6.400, -16.230),
				rot: new THREE.Vector3(0, 0, 0),
				name: 'prmedia_fypon',
				needRotation: true

			},
			{
				pos: new THREE.Vector3(-8.310, -6.600, -16.230),
				rot: new THREE.Vector3(0, 0, 0),
				name: 'prmedia_thermatru',
				needRotation: true

			},
		],
		imageElements: [

			{
				pos: new THREE.Vector3(11.44, -2.2, -16.0),
				name: 'ImageEl_larson',
				link: 'https://www.larsondoors.com/',
				rot: new THREE.Vector3(0, -0.140, 0)

			},
			{
				pos: new THREE.Vector3(11.44, -3.5, -16.0),
				name: 'ImageEl_fiberon',
				link: 'https://fiberon2023.thetunagroup.com/',
				rot: new THREE.Vector3(0, -0.140, 0)

			},
			{
				pos: new THREE.Vector3(11.44, -4.85, -16.0),
				name: 'ImageEl_solar_innovations',
				link: 'https://solarinnovations.com/',
				rot: new THREE.Vector3(0, -0.140, 0)

			},
			{
				pos: new THREE.Vector3(11.44, -6.06, -16.0),
				name: 'ImageEl_fortune_brands',
				link: 'https://www.fbin.com/media-resources/',
				rot: new THREE.Vector3(0, -0.140, 0)

			}
		]



	},
	{
		key: 'fypon_arial', modelSrc: 'balance_panorama.fbx', backImg: 'fypon_arial.jpg', apiId: 4,
		backRot: 0, hotPosY0: 0,
		campos: [
			{ x: 0.2448, y: -0.01352, z: 0.00058, fov: fypon_area_fov, backImg: 'balance-back_0.jpg' },

		],
		control: [
			{ azimuth: { max: 1.6, min: 1.6 }, polar: { max: polarMaxAngle, min: polarMinAngle } },

		],
		frames: [{
			frameKey: 'fypon_video',
			type: 'video',
			fileName: 'Rotating_Door',
			size: { w: 1.8, h: 2.3 },
			pos: { x: -26.415, y: 1.376, z: -6.009 },
			rot: { x: 3.081, y: 1.421, z: -3.142 },
			scale: { x: 1.130, y: 0.960 }
		},],

		navigationElements: [
			{
				name: 'prmedia',
				pos: { x: -17.000, y: -4.384, z: 10.330 },
				rot: { x: 3.140, y: 5.411, z: -3.123 },
				scale: { x: 2.260, y: 0.830, z: 1.230 },
				size: { w: 1.8, h: 2.3 },
				shadow: { pos: { x: -13.880, y: -1.764, z: 12.330 }, rot: { x: 3.140, y: 5.411, z: -3.123 }, scale: { x: 1.860, y: 1.230, z: 1 } }
			},
			{
				name: 'thermatru', pos: { x: -19.320, y: -2.694, z: -13.990 }, rot: { x: 0, y: 0, z: 0 }, scale: { x: 2.210, y: 0.780, z: 1 }, size: { w: 1.8, h: 2.3 },
				shadow: { pos: { x: -13.880, y: -1.764, z: 12.330 }, rot: { x: 3.140, y: 5.411, z: -3.123 }, scale: { x: 1.860, y: 1.230, z: 1 } }
			}
		],
		hotspot: [
			{
				pos: { x: -19.800, y: -2.390, z: 5.830 },
				rot: { x: -0.210, y: -0.490, z: -0.300 },
				rotNeed: true,
				name: 'fypon_advantage',
				ref: 'fypon_arial_hotspot1',
				textPos: { x: 9.770, y: 9.000, z: -4.480 },
				textRot: { x: 0, y: 2.3, z: 0 },
				textName: "New Products",
				color: 0x0079C2
				, type: 'fypon',
				textKey: 'text_fypon_advant'


			},
			{
				pos: { x: -19.300, y: -2.100, z: -0.690 },
				rot: { x: -0.210, y: -0.490, z: -0.300 },
				rotNeed: true,

				name: 'fypon_new_products',
				ref: 'fypon_arial_hotspot2',
				textPos: { x: 9.770, y: 9.000, z: -4.480 },
				textRot: { x: 0, y: 2.2, z: 0 },
				textName: "Explore Fypon",
				color: 0x0079C2
				, type: 'fypon',
				textKey: 'text_fypon_product'


			},
			{
				pos: { x: -20.000, y: -1.920, z: -5.850 },
				rot: { x: -0.210, y: -0.490, z: -0.300 },
				rotNeed: true,

				name: 'tools_support_fypon',
				ref: 'fypon_arial_hotspot3',
				textPos: { x: 9.770, y: 9.000, z: -4.480 },
				textRot: { x: 0, y: 1.9, z: 0 },
				textName: "Explore Fypon",
				color: 0x0079C2
				, type: 'fypon',
				textKey: 'text_fypon_explore'


			},


		],
		infospot: []
	},
	{
		key: 'fypon_advantage', modelSrc: 'balance_panorama.fbx', backImg: 'fypon_1.jpg', apiId: 4,
		backRot: 0, hotPosY0: 0,
		campos: [
			{ x: 0.2448315, y: 1.501256, z: 0.0219, fov: 70, backImg: 'balance-back_0.jpg' },

		],
		control: [
			{ azimuth: { max: 1.55, min: 0.35 }, polar: { max: polarMaxAngle, min: polarMinAngle } },

		],

		navigationElements: [
			{ name: 'prmedia', pos: { x: -8.705, y: -3.124, z: 10.620 }, rot: { x: 3.140, y: 5.411, z: -3.123 }, scale: { x: 1.460, y: 1, z: 1 }, size: { w: 1.8, h: 2.3 } },
			{ name: 'thermatru', pos: { x: 13.895, y: -2.184, z: -16.500 }, rot: { x: 0, y: 0, z: 0 }, scale: { x: 1.460, y: 1, z: 1 }, size: { w: 1.8, h: 2.3 } }
		],
		frames: [{
			frameKey: 'fypon_video', type: 'video', fileName: 'Rotating_Door', size: { w: 1.8, h: 2.3 },
			pos: { x: 6.125, y: -0.274, z: -25.079 },
			rot: { x: -0.031, y: 0.431, z: 0.010 },
			scale: { x: 2.070, y: 2.050 }

		},],

		hotspot: [
			{
				pos: { x: -9.040, y: -5.640, z: -10.320 },
				rot: { x: -1.422, y: -0.088, z: 0.152 },
				name: 'fypon_new_products',
				ref: 'advantage_hotspot1',
				textPos: { x: 9.770, y: 9.000, z: -4.480 },
				textRot: { x: 0, y: 0.840, z: 0 },
				textName: "New Products",
				color: 0x0079C2
				, type: 'fypon',
				textKey: 'text_fypon_product'

			},

			{
				pos: { x: 10.730, y: -5.390, z: -20.270 },
				rot: { x: -1.422, y: -0.088, z: 0.152 },
				name: 'tools_support_fypon',
				ref: 'advantage_hotspot3',
				textPos: { x: -0.620, y: 9.000, z: 13.700 },
				textRot: { x: 0, y: -0.3, z: 0 },
				textName: "Tools & Support",
				color: 0x0079C2
				, type: 'fypon',
				textKey: 'text_fypon_explore'

			},
		],
		infospot: [
			{
				pos: new THREE.Vector3(-13.100, 0.630, 3.440),
				rot: new THREE.Vector3(-1.422, -0.088, 0.152),
				name: 'trust_experts_modal',
				ref: 'trust_experts_modal',
				needRotation: false,
				color: 'blue'

			},

			{
				pos: new THREE.Vector3(-13.100, -1.270, 1.389),
				rot: new THREE.Vector3(-1.422, -0.088, 0.152),
				name: 'discover_fypon_modal',
				ref: 'discover_fypon_modal',
				needRotation: false,
				color: 'blue',

			},
			{
				pos: new THREE.Vector3(-13.100, 1.910, -6.240),
				rot: new THREE.Vector3(-1.422, -0.088, 0.152),
				name: 'takeoff_solution_modal',
				ref: 'takeoff_solution_modal',
				needRotation: false,
				color: 'blue'
			},

			{
				pos: new THREE.Vector3(-13.100, -0.970, -3.960),
				rot: new THREE.Vector3(-1.422, -0.088, 0.152),
				name: 'ordinary_extraordinary_modal',
				ref: 'ordinary_extraordinary_modal',
				needRotation: false,
				color: 'blue'

			},
			{
				pos: new THREE.Vector3(-13.100, -3.790, -6.180),
				rot: new THREE.Vector3(-1.422, -0.088, 0.152),
				name: 'estimating_jobs_modal',
				ref: 'estimating_jobs_modal',
				needRotation: false,
				color: 'blue'

			},

			{
				pos: new THREE.Vector3(-16.500, -5.480, -9.640),
				rot: new THREE.Vector3(-1.422, -0.088, 0.152),
				name: 'takeoff_service',
				needRotation: false

			},
			{
				pos: new THREE.Vector3(-16.030, -5.370, 0.640),
				rot: new THREE.Vector3(-1.422, -0.088, 0.152),
				name: 'discover_fypon',
				needRotation: false

			},
		]


	},
	{
		key: 'fypon_new_products', modelSrc: 'balance_panorama.fbx', backImg: 'fypon_2.jpg', apiId: 4,
		backRot: 0, hotPosY0: 0,
		campos: [
			{ x: 0.2434, y: 0.0115, z: 0.00281, fov: 75, backImg: 'balance-back_2.jpg' },
		],
		control: [
			{ azimuth: { max: 2.1, min: 0.85 }, polar: { max: polarMaxAngle, min: polarMinAngle } },
		],

		navigationElements: [
			{ name: 'prmedia', pos: { x: -2.515, y: -4.084, z: 18.040 }, rot: { x: 3.140, y: 5.411, z: -3.123 }, scale: { x: 1.460, y: 1, z: 1 }, size: { w: 1.8, h: 2.3 } },
			{ name: 'thermatru', pos: { x: 5.715, y: -2.554, z: -15.710 }, rot: { x: 0, y: 0, z: 0 }, scale: { x: 1.460, y: 1, z: 1 }, size: { w: 1.8, h: 2.3 } }
		],
		frames: [{
			frameKey: 'fypon_video', type: 'video', fileName: 'Rotating_Door', size: { w: 1.8, h: 2.3 },
			pos: { x: -12.315, y: -0.724, z: -21.309 },
			rot: { x: -3.142, y: 2.231, z: -3.142 },
			scale: { x: 3.200, y: 3.280 }

		}],
		hotspot: [

			{
				pos: { x: -8.580, y: -4.260, z: 6.580 },
				rot: { x: -1.422, y: -0.088, z: 0.152 },
				ref: 'new_product_hotspot1',
				name: 'fypon_advantage',
				textPos: { x: 9.770, y: 9.000, z: -4.480 },
				textRot: { x: 0, y: 2.1, z: 0 },
				textName: "The Fypon \nAdvantage",
				color: 0x0079C2
				, type: 'fypon',
				textKey: 'text_fypon_advant'


			},


			{
				pos: { x: -6.920, y: -3.300, z: -5.610 },
				rot: { x: -1.422, y: -0.088, z: 0.152 },
				ref: 'new_product_hotspot3',
				name: 'tools_support_fypon',
				textPos: { x: -0.620, y: 9.000, z: 13.700 },
				textRot: { x: 0, y: 1.1, z: 0 },
				textName: "Tools & Support",
				color: 0x0079C2
				, type: 'fypon',
				textKey: 'text_fypon_explore'


			},
		],
		infospot: [
			{
				pos: new THREE.Vector3(-17.200, -4.430, -0.370),
				rot: new THREE.Vector3(-1.422, -0.088, 0.152),
				name: 'shutter_smoother',
				needRotation: false

			},

		]


	},
	{
		key: 'fypon_explore', modelSrc: 'balance_panorama.fbx', backImg: 'fypon_3.jpg', apiId: 4,
		backRot: 0, hotPosY0: 0,
		campos: [
			{ x: 0.1477606581203571, y: 0.006714357510813092, z: 0.13143235650347293, fov: 60, backImg: 'balance-back_2.jpg' },
		],
		control: [
			{ azimuth: { max: 2.8, min: 1.8 }, polar: { max: polarMaxAngle, min: polarMinAngle } },
		],
		navigationElements: [
			{ name: 'prmedia', pos: { x: 6.925, y: -2.664, z: 16.800 }, rot: { x: 3.140, y: 5.411, z: -3.123 }, scale: { x: 1.460, y: 1, z: 1 }, size: { w: 1.8, h: 2.3 } },
			{ name: 'thermatru', pos: { x: -11.175, y: -2.534, z: -15.050 }, rot: { x: 0, y: 0, z: 0 }, scale: { x: 1.460, y: 1, z: 1 }, size: { w: 1.8, h: 2.3 } }
		],
		frames: [{
			frameKey: 'fypon_video', type: 'video', fileName: 'Rotating_Door', size: { w: 1.8, h: 2.3 },
			pos: { x: -22.135, y: -1.004, z: 11.351 },
			rot: { x: -3.142, y: 1.411, z: -3.142 },
			scale: { x: 4.170, y: 4.100, z: 1 }

		}],
		hotspot: [

			{
				pos: { x: -11.430, y: -5.290, z: 14.270 },
				rot: { x: -1.422, y: -0.088, z: 0.152 },
				ref: 'explore_hotspot1',
				name: 'fypon_advantage',
				textPos: { x: 9.770, y: 9.000, z: -4.480 },
				textRot: { x: 0, y: 2.8, z: 0 },
				textName: "The Fypon \nAdvantage",
				color: 0x0079C2
				, type: 'fypon',
				textKey: 'text_fypon_advant'


			},

			{
				pos: { x: -14.030, y: -5.680, z: -0.730 },
				rot: { x: -1.422, y: -0.088, z: 0.152 },
				ref: 'explore_hotspot2',
				name: 'fypon_new_products',
				textPos: { x: 9.770, y: 9.000, z: -4.480 },
				textRot: { x: 0, y: 1.7, z: 0 },
				textName: "Explore Fypon",
				color: 0x0079C2
				, type: 'fypon',
				textKey: 'text_fypon_product'

			},
			{
				pos: { x: -4.230, y: -5.400, z: -20.710 },
				rot: { x: -1.422, y: -0.088, z: 0.152 },
				ref: 'explore_hotspot3',
				name: 'tools_support_fypon',
				textPos: { x: -0.620, y: 9.000, z: 13.700 },
				textRot: { x: 0, y: 21.150, z: 0 },
				textName: "Tools & Support",
				color: 0x0079C2
				, type: 'fypon',
				textKey: 'text_fypon_explore'


			},
		],
		infospot: [
			{
				pos: new THREE.Vector3(-14.110, -3.060, -16.860),
				rot: new THREE.Vector3(-1.422, 0.861, 0.152),
				name: 'fypon_explore',
				needRotation: true
			},

		]


	},
	{
		key: 'tools_support_fypon', modelSrc: 'balance_panorama.fbx', backImg: 'fypon_3.jpg', apiId: 4,
		backRot: 0, hotPosY0: 0,
		campos: [
			{ x: 0.24339587852350902, y: 0.011173746158585246, z: -0.00040474010474522243, fov: 65, backImg: 'balance-back_2.jpg' },
		],
		control: [
			{ azimuth: { max: 2.9, min: 1.5 }, polar: { max: polarMaxAngle, min: polarMinAngle } },
		],
		navigationElements: [
			{ name: 'prmedia', pos: { x: 10.565, y: -3.124, z: 21.030 }, rot: { x: 3.140, y: 5.411, z: -3.123 }, scale: { x: 1.460, y: 1, z: 1 }, size: { w: 1.8, h: 2.3 } },
			{ name: 'thermatru', pos: { x: -7.215, y: -5.424, z: -15.920 }, rot: { x: 0, y: 0, z: 0 }, scale: { x: 1.460, y: 1, z: 1 }, size: { w: 1.8, h: 2.3 } }
		],
		frames: [{
			frameKey: 'fypon_video', type: 'video', fileName: 'Rotating_Door', size: { w: 1.8, h: 2.3 },
			pos: { x: -22.135, y: -1.004, z: 11.351 },
			rot: { x: -3.142, y: 1.411, z: -3.142 },
			scale: { x: 4.170, y: 4.100, z: 1 }

		}],

		hotspot: [

			{
				pos: { x: 8.830, y: -5.290, z: 24.690 },
				rot: { x: -1.422, y: -0.088, z: 0.152 },
				ref: 'tools_support_hotspot1',
				name: 'fypon_advantage',
				textPos: { x: 9.770, y: 9.000, z: -4.480 },
				textRot: { x: 0, y: 3.1, z: 0 },
				textName: "The Fypon \nAdvantage",
				color: 0x0079C2
				, type: 'fypon',
				textKey: 'text_fypon_advant'


			},

			{
				pos: { x: -10.900, y: -5.680, z: 11.410 },
				rot: { x: -1.422, y: -0.088, z: 0.152 },
				ref: 'tools_support_hotspot2',
				name: 'fypon_new_products',
				textPos: { x: 9.770, y: 9.000, z: -4.480 },
				textRot: { x: 0, y: 2.340, z: 0 },
				textName: "Explore Fypon",
				color: 0x0079C2
				, type: 'fypon',
				textKey: 'text_fypon_product'


			},
			{
				pos: { x: -10.900, y: -5.280, z: -13.300 },
				rot: { x: -1.422, y: -0.088, z: 0.152 },
				name: 'thermatru_difference',
				ref: 'tools_support_hotspot3',
				textPos: { x: 8.430, y: 9.760, z: -11.960 },
				textRot: { x: -3.142, y: 0.8, z: -3.142 },
				textName: "The Therma-Tru \n Difference ",
				color: 'red',
				type: 'thermatru',
				textKey: 'text_therma_differ',
				guided_path_show: true
			},

		],

		infospot: [
			{
				pos: new THREE.Vector3(-18.970, -5.180, 5.950),
				rot: new THREE.Vector3(-1.422, 0.861, 0.152),
				name: 'fypon_explore',
				needRotation: false
			},
			{
				pos: new THREE.Vector3(-16.960, -5.600, -14.480),
				rot: new THREE.Vector3(0, 1.181, 0),
				name: 'fypon_explore_more_tools',
				needRotation: true
			},

		],
		imageElements: [

			{
				pos: new THREE.Vector3(-18.000, -6.800, -10.820),
				name: 'Fypon_Tools_Support_Subheader_Link',
				link: 'https://fypon.com/',
				rot: new THREE.Vector3(0, 1.271, 0)

			}

		]

	},
]



export function Get2DPos(obj, cWidth, cHeight, camera) {
	var vector = new THREE.Vector3();
	var widthHalf = 0.5 * cWidth;
	var heightHalf = 0.5 * cHeight;
	obj.updateMatrixWorld();
	vector.setFromMatrixPosition(obj.matrixWorld);
	vector.project(camera);
	vector.x = (vector.x * widthHalf) + widthHalf;
	vector.y = - (vector.y * heightHalf) + heightHalf;
	return { x: vector.x, y: vector.y };
};


export const hotspots = [
	{
		top: '27%',
		left: '24%',
		title: 'Thermatru Doors',
		redirectionlink: 'thermatru',
		classname: 'border-red'
	},
	{
		top: '22%',
		left: '47%',
		title: 'PR & Media',
		redirectionlink: 'pr_media',
		classname: 'border-white'
	},
	{
		top: '34%',
		left: '64%',
		title: 'Fypon',
		redirectionlink: 'fypon',
		classname: 'border-blue'
	},

]

export const thermatruhotspots = [
	{
		top: '63%',
		left: '22%',
		title: 'Thermatru Difference',
		redirectionlink: 'thermatru_difference'
	},
	{
		top: '55%',
		left: '36%',
		title: 'New Products',
		redirectionlink: 'thermatru_new_products'
	},
	{
		top: '78%',
		left: '54%',
		title: 'Explore Fypon',
		redirectionlink: 'thermatru_tools_support'
	},
	{
		top: '57%',
		left: '77%',
		title: 'Tools & Support',
		redirectionlink: 'thermatru_tools_support'
	},

]
export const Fyponhotspots = [
	{
		top: '75%',
		left: '35%',
		title: 'Fypon Advantage',
		redirectionlink: 'fypon_advantage'
	},
	{
		top: '70%',
		left: '48%',
		title: 'New Products',
		redirectionlink: 'fypon_new_products'
	},
	{
		top: '71%',
		left: '61%',
		title: 'Explore Fypon',
		redirectionlink: 'tools_support_fypon'
	},
	// {
	// 	top : '65%',
	// 	left : '67%',
	// 	title : 'Tools & Support',
	// 	redirectionlink : 'tools_support_fypon'
	// },

]
export function SetTween(obj, attr, info, easeTime) {
	var tweenData = {};
	const easeType = Easing.Cubic.InOut;
	if (attr === "opacity") tweenData = { 'opacity': info };
	else if (attr === "position") tweenData = { 'position.x': info.x, 'position.y': info.y, 'position.z': info.z };
	else if (attr === "intensity") tweenData = { 'intensity': info };
	else if (attr === "scale") tweenData = { 'scale.x': info.x, 'scale.y': info.y, 'scale.z': info.z };
	else if (attr === "fov") tweenData = { 'fov': info };
	// else if (attr === "color") tweenData = {'r': info, 'g':info, 'b':info};

	//console.log(tweenData)
	new Tween(obj).to(tweenData, easeTime).easing(easeType).start();
}
